/* esm.sh - @radix-ui/react-dialog@1.1.23 */
export * from "/*@radix-ui/react-dialog@1.1.23/esnext/react-dialog.mjs";
